const CODES = [
  { code: "EO", label: "EO", title: "En ordre" },
  { code: "UN", label: "UN", title: "Usure normale" },
  { code: "D", label: "D", title: "Défaut / usure anormale" },
  { code: "SO", label: "SO", title: "Sans objet" },
];

export default function CodeSegment({ value, onChange, disabled, testidPrefix }) {
  return (
    <div className="grid grid-cols-4 gap-1.5" role="group">
      {CODES.map((c) => {
        const selected = value === c.code;
        let cls = "border border-dd-light text-dd-night bg-white hover:bg-dd-light/50";
        if (selected) {
          cls = c.code === "D"
            ? "bg-destructive text-white border-destructive"
            : "bg-dd-blue text-white border-dd-blue";
        }
        return (
          <button
            key={c.code}
            type="button"
            title={c.title}
            disabled={disabled}
            data-testid={testidPrefix ? `${testidPrefix}-${c.code}` : undefined}
            onClick={() => onChange(selected ? "" : c.code)}
            className={`h-11 min-h-[44px] rounded-md text-sm font-semibold transition-colors disabled:opacity-50 ${cls}`}
          >
            {c.label}
          </button>
        );
      })}
    </div>
  );
}
